import {route} from '@/router/route-utils'

const prefix = '/society';

const routes = [

    route(
        prefix + '/contacts', 'society.contacts.list', {
            components : {
                main: () => import('./views/SocietyContactsListView')
            },
            requiresAuth: true,
            layout: 'LayoutFull',
            title: 'Contatti',
            breadcrumb: [
                {text: 'Contatti', active: true},
            ],
        }
    ),

];

export default routes
